import React from 'react';
import { IconType } from 'react-icons';
import { MdRefresh } from 'react-icons/md';

interface PageHeaderProps {
  icon: IconType;
  title: string;
  description: string;
  iconColor?: string;
  reload?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon: Icon,
  title,
  description,
  iconColor = 'text-blue-600',
  reload,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-3">
          <Icon className={`text-2xl ${iconColor}`} />
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        </div>
        {reload && (
          <button
            onClick={reload}
            className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            title="Reload data"
          >
            <MdRefresh className="w-4 h-4 mr-2" />
            Reload
          </button>
        )}
      </div>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export default PageHeader;
